/* jshint esnext: true */

const moves = {

	move: null,

	/**
	 * Store the next direction to travel.
	 */
	add: function( direction ) {

		this.move = direction;

	},


	/**
	 * Get the next direction and reset the value.
	 */
	next: function() {

		let next = this.move;

		this.reset();

		return next;

	},


	/**
	 * Reset the move info.
	 */
	reset: function( defaultDirection = null ) {

		this.move = defaultDirection;

	}

};